import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { MODAL_TYPE_PDF_VIEW_IMAGE, MODAL_TYPE_SOLUTION_VIDEO, showModal, } from '../../../actions/ModalActions';
import { showNotification as showNotificationAction } from '../../../actions/NotificationActions';
import { API_GET_LIST_RECOMMENDATION_SOLUTION, API_GET_ONE_SOLUTION, apiGetListRecommendationSolution, apiGetOneSolution, } from '../../../actions/OneSolutionActions';
import { ENABLE_INQUIRY } from '../../../define/consts/solution_order';
import { NOT_FOUND } from '../../../define/response';
import { isClient as isClientMember } from '../../../helpers/auth';
import { propArrayShape, propBool, propFunc, propShape, PropTypesAuthToken, propMatch, propHistory, } from '../../../helpers/custom-prop-types';
import { isLoadingApis } from '../../../helpers/fetch';
import ForbiddenOne from '../../Forbidden/ForbiddenOne';
import Layout from '../../Layout';
import AuthenticationHoc from '../../System/AuthenticationHoc';
import ModalPortal from '../../Ui/Modal/ModalPortal';
import PdfImageModal from '../../Ui/Modal/Pdf/PdfImageModal';
import WrapVideoContentModal from '../../Ui/Modal/WrapVideoContentModal';
import OneMainItem from './OneMainItem';
class One extends Component {
    constructor(props) {
        super(props);
        this.runLoad = () => {
            const { auth, match } = this.props;
            const { getOneSolution } = this.props;
            this.setState({ currentTab: 0 });
            getOneSolution(match.params.id, isClientMember(auth));
        };
        this.onClickOrder = () => {
            const { auth, history, item, showNotification } = this.props;
            const { inquiryStatus } = item;
            if (!isClientMember(auth) || inquiryStatus !== ENABLE_INQUIRY) {
                showNotification('問い合わせ中の面談希望数が上限のため、問い合わせできません。');
                return;
            }
            history.push(`/solutions/${item.id}/order`);
        };
        this.onClickProffitOrder = () => {
            const { history, item } = this.props;
            history.push(`/solutions/${item.id}/proffit_order`);
        };
        this.onClickChangeTab = (index) => {
            this.setState({ currentTab: index });
        };
        this.state = { currentTab: 0 };
    }
    componentDidMount() {
        const { item } = this.props;
        if (!item) {
            // 読み込み済みの場合はデータの追加読み込みを行わない
            this.runLoad();
        }
    }
    componentDidUpdate(prevProps) {
        const { match } = this.props;
        if (prevProps.match.url !== match.url) {
            this.runLoad();
        }
    }
    render() {
        const { auth, isForbidden, isLoading, isLoadingRecommendation, item, recommendations, showSliderModal, showVideoModal, } = this.props;
        const { videoContent } = item || {};
        if (isForbidden) {
            const isClient = isClientMember(auth);
            // 権限エラーの場合
            if (isClient) {
                // 企業ユーザの場合はマイページ戻す
                return _jsx(CustomRedirect, { to: '/mypage' });
            }
            // コンサルタントの場合は表示をさせない
            return (_jsx(ForbiddenOne, { text: '他のコンサルタントの方のプロジェクト事例はノウハウを保護するため、開示できません。' }));
        }
        const { currentTab } = this.state;
        return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main layout_solution_one' }, { children: [_jsx(OneMainItem, { auth: auth, changeTab: this.onClickChangeTab, currentTab: currentTab, isDemo: false, isLoading: isLoading || !item, isLoadingRecommendation: isLoadingRecommendation, item: item, onClickOrder: this.onClickOrder, onClickProffitOrder: this.onClickProffitOrder, onClickThumbnail: showSliderModal, onClickVideo: showVideoModal, recommendations: recommendations }), _jsxs(ModalPortal, Object.assign({ selector: '#app' }, { children: [_jsx(WrapVideoContentModal, { modalType: MODAL_TYPE_SOLUTION_VIDEO, src: videoContent || '' }), _jsx(PdfImageModal, {})] }))] })));
    }
}
One.propTypes = {
    auth: PropTypesAuthToken.isRequired,
    getOneSolution: propFunc().isRequired,
    history: propHistory(),
    isForbidden: propBool().isRequired,
    isLoading: propBool().isRequired,
    isLoadingRecommendation: propBool().isRequired,
    item: propShape(),
    match: propMatch(),
    recommendations: propArrayShape().isRequired,
    showNotification: propFunc().isRequired,
    showSliderModal: propFunc().isRequired,
    showVideoModal: propFunc().isRequired,
};
One.defaultProps = {
    item: null,
};
const mapStateToProps = ({ auth, fetch, oneSolution }, { match }) => {
    const one = oneSolution[match.params.id] || {};
    return {
        auth,
        isForbidden: !!one.forbidden,
        isLoading: isLoadingApis(fetch, API_GET_ONE_SOLUTION),
        isLoadingRecommendation: isLoadingApis(fetch, API_GET_LIST_RECOMMENDATION_SOLUTION),
        item: one.one,
        recommendations: one.recommendation || [],
    };
};
const mapDispatchToProps = (dispatch, { history }) => ({
    getOneSolution: (id, isClient) => {
        dispatch(apiGetOneSolution(id, {
            reject: {
                [NOT_FOUND]: () => history.push('/error/notfound'),
            },
            resolve: () => {
                if (isClient) {
                    // おすすめのプロジェクト事例を追加
                    dispatch(apiGetListRecommendationSolution(id));
                }
            },
        }));
    },
    showNotification: (message) => dispatch(showNotificationAction(message)),
    showSliderModal: (images, initialSlide, item) => dispatch(showModal(MODAL_TYPE_PDF_VIEW_IMAGE, null, {
        dataAttributes: {
            'data-title': item.title,
        },
        images,
        initialSlide,
    })),
    showVideoModal: () => dispatch(showModal(MODAL_TYPE_SOLUTION_VIDEO)),
});
const enhance = compose(AuthenticationHoc({
    isCanUseProffitMart: true,
    isMember: true,
    isPreClient: false,
    isPreview: true,
    notPreClientRedirectTo: '/mypage',
}), connect(mapStateToProps, mapDispatchToProps));
export default enhance(One);
